export default  {
    knobX: 71,
    knobY: 71,
    svg:`

    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="204px" height="204px" viewBox="0 0 204 204" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="02fb5b45-6017-f8da-5df6-0b9e6cc0f188">
            <stop stop-color="#444040" stop-opacity="0.51098279" offset="0%"/>
            <stop stop-color="#131111" stop-opacity="0.893200861" offset="100%"/>
        </linearGradient>
        <circle id="913515e3-116d-c734-bab7-402137ec4375" cx="98.0392157" cy="98.0392157" r="98.0392157"/>
        <filter x="-3.3%" y="-3.3%" width="106.6%" height="106.6%" filterUnits="objectBoundingBox" id="40d794cb-eb72-98db-5e37-f36d6834341d">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="ee0a5bf2-27ac-bbba-76c5-b9ad070d33fd">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="fd63ac58-f019-cf29-508c-c1b7821ebb9b" cx="98" cy="98" r="86"/>
        <filter x="-4.1%" y="-3.5%" width="108.1%" height="108.1%" filterUnits="objectBoundingBox" id="eb4f1c48-2370-fad3-b234-2b2712aa57c8">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="70f4f9ff-1199-5366-0cca-eb055430a393" cx="71" cy="71" r="71"/>
        <filter x="-8.8%" y="-8.8%" width="117.6%" height="117.6%" filterUnits="objectBoundingBox" id="04bf4f50-2dea-685f-ba34-7c9bee48a8c2">
            <feGaussianBlur stdDeviation="10" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0.780392157   0 0 0 0 0.925490196   0 0 0 0 0.619607843  0 0 0 1 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <path d="M70.3846154,6 L86.7692308,67.0983622 C82.5162083,68.7146383 77.0546698,69.591634 70.3846154,69.7293492 C63.7145609,69.8670644 58.2530225,68.9900687 54,67.0983622 L70.3846154,6 Z" id="094ac88e-425f-a816-c957-0873fe3d898a"/>
        <filter x="-71.7%" y="-33.7%" width="243.4%" height="173.7%" filterUnits="objectBoundingBox" id="2cbe7e17-4794-f59c-1e17-ed21c1f67183">
            <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="7.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.862745098   0 0 0 0 0.988235294   0 0 0 0 0.729411765  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s15" transform="translate(4.000000, 4.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#40d794cb-eb72-98db-5e37-f36d6834341d)" xlink:href="#913515e3-116d-c734-bab7-402137ec4375"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#02fb5b45-6017-f8da-5df6-0b9e6cc0f188)" fill-rule="evenodd" xlink:href="#913515e3-116d-c734-bab7-402137ec4375"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#eb4f1c48-2370-fad3-b234-2b2712aa57c8)" xlink:href="#fd63ac58-f019-cf29-508c-c1b7821ebb9b"/>
                    <use fill="" fill-rule="evenodd" xlink:href="#fd63ac58-f019-cf29-508c-c1b7821ebb9b"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="url(#ee0a5bf2-27ac-bbba-76c5-b9ad070d33fd)" fill-rule="evenodd" xlink:href="#fd63ac58-f019-cf29-508c-c1b7821ebb9b"/>
                </g>
                <g id="knob" transform="translate(27.431373, 27.431373)">
                    <g id="Oval-5">
                        <use fill="#322E2E" fill-rule="evenodd" xlink:href="#70f4f9ff-1199-5366-0cca-eb055430a393"/>
                        <use fill="black" fill-opacity="1" filter="url(#04bf4f50-2dea-685f-ba34-7c9bee48a8c2)" xlink:href="#70f4f9ff-1199-5366-0cca-eb055430a393"/>
                        <use stroke="#C7EC9E" stroke-width="5" xlink:href="#70f4f9ff-1199-5366-0cca-eb055430a393"/>
                    </g>
                    <g id="Rectangle-Copy-2" transform="translate(70.384615, 37.871684) scale(1, -1) translate(-70.384615, -37.871684) ">
                        <use fill="black" fill-opacity="1" filter="url(#2cbe7e17-4794-f59c-1e17-ed21c1f67183)" xlink:href="#094ac88e-425f-a816-c957-0873fe3d898a"/>
                        <use fill="#C7EC9E" fill-rule="evenodd" xlink:href="#094ac88e-425f-a816-c957-0873fe3d898a"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`
}